module.exports = __webpack_public_path__ + "img/hm_bim.3e9e627d.png";